import React from 'react';
import { compose } from 'redux';
import { AppState } from '@om-fe/core/core/types';
import { connect } from 'react-redux';
import getSlice from '@om-fe/core/utils/get-slice';
import { FavoriteMatchListPublicProps, FavoriteMatchListDefaultProps } from './favorite-match-list.constants';
import FavoriteMatchList from './favorite-match-list';
import { DisciplineLiveStatus } from '@om-fe/models';
import { bem } from '@om-fe/widgets';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import { FavoritesStoreState } from '@om-fe/core/components/favorite-button/favorite-state.constants';
import { FavoritesStoreState as FavoritesStoreStateV2  } from '@om-fe/core/components/favorite-events/favorite-state.constants';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
export interface FavoriteMatchListStoreProps {
    readonly userID?: string | number;
    readonly ready: boolean;
    readonly favoriteMatchIds?: string[];
}

type FavoriteMatchListProps = Partial<FavoriteMatchListDefaultProps>
    & FavoriteMatchListPublicProps
    & FavoriteMatchListStoreProps
    & I18nContextInterface;
    
function FavoriteMixedMatchListComponent({
    userID,
    ready,
    favoriteMatchIds,
    mainMarketsLimit,
    matchListLayout,
    eventsNumber,
    marketsHeaderOptions,
}: FavoriteMatchListProps) {
    const { gettext } = useI18NContext();

    if (!ready) {
        return null;
    }

    if (!favoriteMatchIds?.length) {
        return (
            <div className="EmptyList">
                {gettext('No matches currently available')}
            </div>
        );
    }
    
    return (
        <>
            { favoriteMatchIds?.map((id: string) => {
                return (
                    <FavoriteMatchList
                        key={id}
                        activeMatchId={id || null}
                        userID={userID}
                        instanceId={`LiveEventFavorites-${id}`}
                        liveStatus={DisciplineLiveStatus.LIVE}
                        limitNumberOfEvents={eventsNumber}
                        extraClassName={bem('MatchList')}
                        routeName={RouteNames.liveEvent}
                        showMixedMatchListHeader
                        itemLayout={matchListLayout}
                        marketsHeaderOptions={marketsHeaderOptions}
                        mainMarketsLimit={mainMarketsLimit}
                        showMatchListHeader={false}
                        showMarketInMatchListGroupHeader={true}
                        matchId={id}
                    />
                );
            })
            }
        </>
    );
}

const FavoriteMixedMatchList: React.ComponentType<FavoriteMatchListPublicProps> = compose<React.ComponentType<FavoriteMatchListPublicProps>>(
    connect<FavoriteMatchListStoreProps, undefined, FavoriteMatchListPublicProps>(
        (state: AppState): FavoriteMatchListStoreProps => {
            const favoriteEventSlice: FavoritesStoreState | FavoritesStoreStateV2 | undefined = getSlice<FavoritesStoreState | FavoritesStoreStateV2>(state, 'favorites');

            if (!favoriteEventSlice) {
                return {
                    ready: false,
                    favoriteMatchIds: [],
                };
            }
            const { ready } = favoriteEventSlice;
            const favoriteMatchIds: string [] | undefined = favoriteEventSlice && Object.keys(favoriteEventSlice.favoriteMatchItems);
            
            return {
                userID: state.session.info?.userID,
                ready,
                favoriteMatchIds,
            };
        }),
)(FavoriteMixedMatchListComponent);

export default FavoriteMixedMatchList;
